<template>
  <div class="commonTabs">
    <!--closable这里说明home是不能关闭的-->
    <el-tag class="tag"
      :key="tag.name"
      size="small"
      v-for="(tag, index) in tags"
      :closable="tag.name !== 'home'"
      :disable-transitions="false"
      @close="handleClose(tag, index)"
      @click="changeMenu(tag)"
      :effect="$route.name === tag.name ? 'dark' : 'plain'"
    >
      {{ tag.label }}
    </el-tag>
  </div>
</template>

<script>
export default {
  data(){
    return{
      tags:this.$mStore.state.tabsList
    }
  },
  created(){
    console.log(this.$route.name)
  },
  methods: {
    //关闭标签
    handleClose(tag, index) {
      let length = this.tags.length - 1
      //vuex调方法的另一种写法
      this.$mStore.commit('closeTab', tag)

      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tag.name !== this.$route.name) {
        return
      }
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        this.$router.push({ name: this.tags[index - 1].name })
      } else {
        // 否则往右边跳转
        this.$router.push({ name: this.tags[index].name })
      }
    },
    //选择标签跳转路由
    changeMenu(item) {
      console.log(item)
      if(item.name!=this.$route.name){
        this.$router.push({ name: item.name })
        this.$mStore.commit('selectMenu', item);
      }
    }
  }
}
</script>
<style>
.tag{
  margin:5px;
  cursor: pointer;
}
.commonTabs{
  height:34px !important;
  display: flex !important;
  overflow-x: scroll !important;
  background: #fff;
  -webkit-box-shadow: 0px 2px 2px 0px rgb(0 0 0 / 10%);
  box-shadow: 0px 2px 2px 0px rgb(0 0 0 / 10%);
  z-index: 10;
}
</style>


// WEBPACK FOOTER //
// src/components/common/commonTab.vue